module.exports = __webpack_public_path__ + "images/emoji/zero.f187756971fe3a073bb1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/zero.png
// module id = uD3O
// module chunks = 24